import React from 'react'

import dashboardActiveIcon from '../../assets/GeoLocationAsserts/HeaderIcons/dashboardActive.svg';
import dashboardIcon from '../../assets/GeoLocationAsserts/HeaderIcons/dashboardInactive.svg';
import analyticsActiveIcon from '../../assets/GeoLocationAsserts/HeaderIcons/analyticsActive.svg';
import analyticsIcon from '../../assets/GeoLocationAsserts/HeaderIcons/analyticsInactive.svg';
import reportAtiveIcon from '../../assets/GeoLocationAsserts/HeaderIcons/reportActive.svg';
import reportIcon from '../../assets/GeoLocationAsserts/HeaderIcons/reportInactive.svg';
import setupActiveIcon from '../../assets/GeoLocationAsserts/HeaderIcons/setupActive.svg';
import setupIcon from '../../assets/GeoLocationAsserts/HeaderIcons/setupInactive.svg';
import geoLocationActiveIcon from '../../assets/GeoLocationAsserts/HeaderIcons/locationActive.svg';
import geoLocationIcon from '../../assets/GeoLocationAsserts/HeaderIcons/locationInactive.svg';
import timeLineEmptyIcon from '../../assets/GeoLocationAsserts/Icons/timelineEmpty.png';

import reportBanner from '../../assets/GeoLocationAsserts/Icons/reportBanner.svg';

import startPin from '../../assets/GeoLocationAsserts/MapIcons/startPin.svg';
import endPin from '../../assets/GeoLocationAsserts/MapIcons/endPin.svg';
import userPin from '../../assets/GeoLocationAsserts/MapIcons/userPin.svg';
import propertyPin from '../../assets/GeoLocationAsserts/MapIcons/propertyPin.png';
import parkingPin from '../../assets/GeoLocationAsserts/MapIcons/parkingPin.svg';

const GeoImages = {
  dashboardActiveIcon,
  dashboardIcon,
  analyticsActiveIcon,
  analyticsIcon,
  reportAtiveIcon,
  reportIcon,
  setupActiveIcon,
  setupIcon,
  geoLocationActiveIcon,
  geoLocationIcon,
  timeLineEmptyIcon,
  reportBanner,
  startPin,
  endPin,
  userPin,
  propertyPin,
  parkingPin
  
};

export default GeoImages